export class RoleType {
  static ADMIN = "admin";
  static MANAGER = "manager";
  static NORMAL = "normal";
}
